import { Component } from '@angular/core';
import { AuthenticationService } from '../../services/authentication/authentication.service';
import {
  FormControl,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { FormFieldModule, TextBoxModule } from '@progress/kendo-angular-inputs';
import {
  catchError,
  combineLatest,
  map,
  switchMap,
  take,
  tap,
  throwError,
} from 'rxjs';
import { BarcodesModule } from '@progress/kendo-angular-barcodes';
import { AsyncPipe } from '@angular/common';
import { RoutingService } from '../../services/routing/routing.service';
import { FormErrorComponent } from '../../shared/components/form-error/form-error.component';
import { LabelModule } from '@progress/kendo-angular-label';
import { ButtonModule } from '@progress/kendo-angular-buttons';
import { TranslatePipe } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'af-setup-totp-mfa',
  imports: [
    FormFieldModule,
    TextBoxModule,
    ReactiveFormsModule,
    BarcodesModule,
    AsyncPipe,
    FormErrorComponent,
    LabelModule,
    ButtonModule,
    TranslatePipe,
  ],
  templateUrl: './setup-totp-mfa.component.html',
  styleUrl: './setup-totp-mfa.component.scss',
})
export class SetupTotpMfaComponent {
  private stagePostfix = environment.stage === 'Prod' ? '' : environment.stage;

  mfa$ = combineLatest([
    this.authenticationService.setupTotpMfa(),
    this.authenticationService.getEmail(),
  ]).pipe(
    map(([mfaSetupDetails, email]) => ({
      qrValue: `otpauth://totp/${email}?secret=${mfaSetupDetails.sharedSecret}&issuer=AutoForm${this.stagePostfix}`,
      manualCode: mfaSetupDetails.sharedSecret,
    }))
  );

  mfaForm = new FormGroup({
    code: new FormControl('', [Validators.required, Validators.minLength(6)]),
  });
  errorMessage?: string;
  constructor(
    private authenticationService: AuthenticationService,
    private routingService: RoutingService
  ) {}

  setupMfa() {
    const { code } = this.mfaForm.value;
    if (!this.mfaForm.valid || !code) {
      this.errorMessage = 'SETUP-TOTP.ERROR-INVALID-CODE';
      return;
    }
    this.authenticationService
      .verifyTotpSetup(code)
      .pipe(
        catchError((error) => {
          console.error({ error });
          if ('message' in error) {
            this.errorMessage = error.message;
          }
          return throwError(() => error);
        }),
        switchMap(() => {
          return this.authenticationService.updateMFAPreference().pipe(
            catchError((error) => {
              console.error({ error });
              if ('message' in error) {
                this.errorMessage = error.message;
              }
              return throwError(() => error);
            })
          );
        }),
        tap(() => this.routingService.navigateToDashboard()),
        take(1)
      )
      .subscribe();
  }
}
